import { useTranslation } from 'react-i18next';
import type { StatusOverview } from '@/mocks/dashboard';

interface Props {
  data: StatusOverview;
}

const cards = [
  { key: 'quotes', icon: 'ri-file-list-3-line', valueKey: 'pendingQuotes' as const },
  { key: 'orders', icon: 'ri-box-3-line', valueKey: 'activeOrders' as const },
  { key: 'messages', icon: 'ri-message-3-line', valueKey: 'unreadMessages' as const },
  { key: 'aiPreviews', icon: 'ri-magic-line', valueKey: 'completedAiPreviews' as const },
  { key: 'payments', icon: 'ri-bank-card-line', valueKey: 'pendingPayments' as const },
  { key: 'shipping', icon: 'ri-truck-line', valueKey: 'inTransitShipments' as const },
];

export default function DashboardStatusCards({ data }: Props) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {cards.map((c) => {
        const val = data[c.valueKey];
        return (
          <div
            key={c.key}
            className="rounded-xl border border-ink-100 bg-white p-3 md:p-4 transition-all hover:shadow-sm hover:border-ink-200"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center bg-white/70">
                <i className={`${c.icon} text-base md:text-lg`} />
              </div>
              {val > 0 && (
                <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-white/80 text-xs font-bold">
                  {val}
                </span>
              )}
            </div>
            <p className="text-xs md:text-sm font-medium text-ink-700 leading-tight">
              {t(`dashboard.status.${c.key}`)}
            </p>
          </div>
        );
      })}
    </div>
  );
}